import {
  AccountCircle as MuiAccountCircle,
  Add as MuiAdd,
  AddRounded as MuiAddRounded,
  AdminPanelSettings as MuiAdminPanelSettings,
  Apartment as MuiApartment,
  ArrowBack as MuiArrowBack,
  ArrowDropDown as MuiArrowDropDown,
  ArrowDownward as MuiArrowDownward,
  ArrowForward as MuiArrowForward,
  ArrowUpward as MuiArrowUpward,
  Assessment as MuiAssessment,
  Assignment as MuiAssignment,
  AutoAwesome as MuiAutoAwesome,
  Badge as MuiBadge,
  Bedtime as MuiBedtime,
  Business as MuiBusiness,
  CalendarMonth as MuiCalendarMonth,
  Cancel as MuiCancel,
  CancelOutlined as MuiCancelOutlined,
  ChatBubble as MuiChatBubble,
  ChatRounded as MuiChatRounded,
  Check as MuiCheck,
  CheckCircle as MuiCheckCircle,
  CheckCircleOutlined as MuiCheckCircleOutline,
  CheckRounded as MuiCheckRounded,
  ChevronLeft as MuiChevronLeft,
  ChevronRight as MuiChevronRight,
  Close as MuiClose,
  CloseRounded as MuiCloseRounded,
  CloudOutlined as MuiCloudOutlined,
  CloudUpload as MuiCloudUpload,
  ContactPage as MuiContactPage,
  ContentCopy as MuiContentCopy,
  Dashboard as MuiDashboard,
  DashboardCustomizeRounded as MuiDashboardCustomizeRounded,
  Delete as MuiDelete,
  DeleteOutlined as MuiDeleteOutline,
  DeleteOutlineRounded as MuiDeleteOutlineRounded,
  Description as MuiDescription,
  DescriptionOutlined as MuiDescriptionOutlined,
  Diversity3 as MuiDiversity3,
  Dns as MuiDns,
  Download as MuiDownload,
  DragIndicator as MuiDragIndicator,
  DragIndicatorRounded as MuiDragIndicatorRounded,
  Edit as MuiEdit,
  EditOutlined as MuiEditOutlined,
  EnergySavingsLeaf as MuiEnergySavingsLeaf,
  EngineeringRounded as MuiEngineeringRounded,
  ErrorOutlined as MuiErrorOutline,
  ExpandMore as MuiExpandMore,
  FavoriteRounded as MuiFavoriteRounded,
  FilterAlt as MuiFilterAlt,
  FilterList as MuiFilterList,
  FitScreen as MuiFitScreen,
  FitnessCenter as MuiFitnessCenter,
  FoodBank as MuiFoodBank,
  Fullscreen as MuiFullscreen,
  FullscreenExit as MuiFullscreenExit,
  Groups as MuiGroups,
  HeightRounded as MuiHeightRounded,
  HelpOutlined as MuiHelpOutline,
  History as MuiHistory,
  Home as MuiHome,
  HourglassEmpty as MuiHourglassEmpty,
  Info as MuiInfo,
  InfoOutlined as MuiInfoOutlined,
  InsertChart as MuiInsertChart,
  InsertDriveFile as MuiInsertDriveFile,
  Key as MuiKey,
  KeyboardArrowDown as MuiKeyboardArrowDown,
  Language as MuiLanguage,
  Link as MuiLink,
  LinkOff as MuiLinkOff,
  Logout as MuiLogout,
  MarkEmailUnread as MuiMarkEmailUnread,
  Menu as MuiMenu,
  MonitorHeart as MuiMonitorHeart,
  MonitorWeight as MuiMonitorWeight,
  MonitorWeightOutlined as MuiMonitorWeightOutlined,
  MoreVert as MuiMoreVert,
  Pause as MuiPause,
  PlayArrow as MuiPlayArrow,
  ToggleOff as MuiToggleOff,
  ToggleOn as MuiToggleOn,
  NavigateBefore as MuiNavigateBefore,
  NavigateNext as MuiNavigateNext,
  Notifications as MuiNotifications,
  People as MuiPeople,
  Person as MuiPerson,
  PersonAdd as MuiPersonAdd,
  PersonAddAlt1 as MuiPersonAddAlt1,
  PhotoCamera as MuiPhotoCamera,
  Pool as MuiPool,
  PrivacyTip as MuiPrivacyTip,
  Quiz as MuiQuiz,
  Refresh as MuiRefresh,
  RefreshRounded as MuiRefreshRounded,
  ReportProblemOutlined as MuiReportProblemOutlined,
  Restaurant as MuiRestaurant,
  Scale as MuiScale,
  School as MuiSchool,
  ScienceOutlined as MuiScienceOutlined,
  Search as MuiSearch,
  SendOutlined as MuiSendOutlined,
  Settings as MuiSettings,
  ShowChart as MuiShowChart,
  Spa as MuiSpa,
  Storage as MuiStorage,
  Straighten as MuiStraighten,
  SupervisorAccount as MuiSupervisorAccount,
  SupervisorAccountOutlined as MuiSupervisorAccountOutlined,
  SwapHoriz as MuiSwapHoriz,
  SwapHorizRounded as MuiSwapHorizRounded,
  SwapVert as MuiSwapVert,
  TableRows as MuiTableRows,
  Today as MuiToday,
  TrackChangesRounded as MuiTrackChangesRounded,
  Translate as MuiTranslate,
  TrendingUpRounded as MuiTrendingUpRounded,
  TuneRounded as MuiTuneRounded,
  ViewAgenda as MuiViewAgenda,
  ViewColumn as MuiViewColumn,
  Visibility as MuiVisibility,
  VisibilityOutlined as MuiVisibilityOutlined,
  VolunteerActivism as MuiVolunteerActivism,
  WarningAmber as MuiWarningAmber,
  Workspaces as MuiWorkspaces,
  ZoomIn as MuiZoomIn,
  ZoomOut as MuiZoomOut,
} from '@mui/icons-material';
import { wrap } from '../wrap';

/**
 * Every icon this application uses, named once, and taking `styles` like every
 * other component here.
 *
 * One barrel rather than the deep module paths the code was using in half its
 * files. `src/components/navIcons.tsx` already argued that case on its own
 * terms: a new deep specifier makes Vite re-run its dependency optimiser
 * mid-session, which invalidates the module graph and fails whatever page load
 * was in flight. The barrel is pre-bundled once.
 *
 * Names are the vendor's, deliberately. A semantic layer over these ("the icon
 * for deleting") is a real idea and a separate one; renaming every icon while
 * also moving it would make both changes unreviewable.
 */

export const AccountCircle = wrap(MuiAccountCircle, 'AccountCircle', { keep: ['fontSize', 'color'] });
export const Add = wrap(MuiAdd, 'Add', { keep: ['fontSize', 'color'] });
export const AddRounded = wrap(MuiAddRounded, 'AddRounded', { keep: ['fontSize', 'color'] });
export const AdminPanelSettings = wrap(MuiAdminPanelSettings, 'AdminPanelSettings', { keep: ['fontSize', 'color'] });
export const Apartment = wrap(MuiApartment, 'Apartment', { keep: ['fontSize', 'color'] });
export const ArrowBack = wrap(MuiArrowBack, 'ArrowBack', { keep: ['fontSize', 'color'] });
export const ArrowDropDown = wrap(MuiArrowDropDown, 'ArrowDropDown', { keep: ['fontSize', 'color'] });
export const ArrowDownward = wrap(MuiArrowDownward, 'ArrowDownward', { keep: ['fontSize', 'color'] });
export const ArrowForward = wrap(MuiArrowForward, 'ArrowForward', { keep: ['fontSize', 'color'] });
export const ArrowUpward = wrap(MuiArrowUpward, 'ArrowUpward', { keep: ['fontSize', 'color'] });
export const Assessment = wrap(MuiAssessment, 'Assessment', { keep: ['fontSize', 'color'] });
export const Assignment = wrap(MuiAssignment, 'Assignment', { keep: ['fontSize', 'color'] });
export const AutoAwesome = wrap(MuiAutoAwesome, 'AutoAwesome', { keep: ['fontSize', 'color'] });
export const Badge = wrap(MuiBadge, 'Badge', { keep: ['fontSize', 'color'] });
export const Bedtime = wrap(MuiBedtime, 'Bedtime', { keep: ['fontSize', 'color'] });
export const Business = wrap(MuiBusiness, 'Business', { keep: ['fontSize', 'color'] });
export const CalendarMonth = wrap(MuiCalendarMonth, 'CalendarMonth', { keep: ['fontSize', 'color'] });
export const Cancel = wrap(MuiCancel, 'Cancel', { keep: ['fontSize', 'color'] });
export const CancelOutlined = wrap(MuiCancelOutlined, 'CancelOutlined', { keep: ['fontSize', 'color'] });
export const ChatBubble = wrap(MuiChatBubble, 'ChatBubble', { keep: ['fontSize', 'color'] });
export const ChatRounded = wrap(MuiChatRounded, 'ChatRounded', { keep: ['fontSize', 'color'] });
export const Check = wrap(MuiCheck, 'Check', { keep: ['fontSize', 'color'] });
export const CheckCircle = wrap(MuiCheckCircle, 'CheckCircle', { keep: ['fontSize', 'color'] });
export const CheckCircleOutline = wrap(MuiCheckCircleOutline, 'CheckCircleOutline', { keep: ['fontSize', 'color'] });
export const CheckRounded = wrap(MuiCheckRounded, 'CheckRounded', { keep: ['fontSize', 'color'] });
export const ChevronLeft = wrap(MuiChevronLeft, 'ChevronLeft', { keep: ['fontSize', 'color'] });
export const ChevronRight = wrap(MuiChevronRight, 'ChevronRight', { keep: ['fontSize', 'color'] });
export const Close = wrap(MuiClose, 'Close', { keep: ['fontSize', 'color'] });
export const CloseRounded = wrap(MuiCloseRounded, 'CloseRounded', { keep: ['fontSize', 'color'] });
export const CloudOutlined = wrap(MuiCloudOutlined, 'CloudOutlined', { keep: ['fontSize', 'color'] });
export const CloudUpload = wrap(MuiCloudUpload, 'CloudUpload', { keep: ['fontSize', 'color'] });
export const ContactPage = wrap(MuiContactPage, 'ContactPage', { keep: ['fontSize', 'color'] });
export const ContentCopy = wrap(MuiContentCopy, 'ContentCopy', { keep: ['fontSize', 'color'] });
export const Dashboard = wrap(MuiDashboard, 'Dashboard', { keep: ['fontSize', 'color'] });
export const DashboardCustomizeRounded = wrap(MuiDashboardCustomizeRounded, 'DashboardCustomizeRounded', { keep: ['fontSize', 'color'] });
export const Delete = wrap(MuiDelete, 'Delete', { keep: ['fontSize', 'color'] });
export const DeleteOutline = wrap(MuiDeleteOutline, 'DeleteOutline', { keep: ['fontSize', 'color'] });
export const DeleteOutlineRounded = wrap(MuiDeleteOutlineRounded, 'DeleteOutlineRounded', { keep: ['fontSize', 'color'] });
export const Description = wrap(MuiDescription, 'Description', { keep: ['fontSize', 'color'] });
export const DescriptionOutlined = wrap(MuiDescriptionOutlined, 'DescriptionOutlined', { keep: ['fontSize', 'color'] });
export const Diversity3 = wrap(MuiDiversity3, 'Diversity3', { keep: ['fontSize', 'color'] });
export const Dns = wrap(MuiDns, 'Dns', { keep: ['fontSize', 'color'] });
export const Download = wrap(MuiDownload, 'Download', { keep: ['fontSize', 'color'] });
export const DragIndicator = wrap(MuiDragIndicator, 'DragIndicator', { keep: ['fontSize', 'color'] });
export const DragIndicatorRounded = wrap(MuiDragIndicatorRounded, 'DragIndicatorRounded', { keep: ['fontSize', 'color'] });
export const Edit = wrap(MuiEdit, 'Edit', { keep: ['fontSize', 'color'] });
export const EditOutlined = wrap(MuiEditOutlined, 'EditOutlined', { keep: ['fontSize', 'color'] });
export const EnergySavingsLeaf = wrap(MuiEnergySavingsLeaf, 'EnergySavingsLeaf', { keep: ['fontSize', 'color'] });
export const EngineeringRounded = wrap(MuiEngineeringRounded, 'EngineeringRounded', { keep: ['fontSize', 'color'] });
export const ErrorOutline = wrap(MuiErrorOutline, 'ErrorOutline', { keep: ['fontSize', 'color'] });
export const ExpandMore = wrap(MuiExpandMore, 'ExpandMore', { keep: ['fontSize', 'color'] });
export const FavoriteRounded = wrap(MuiFavoriteRounded, 'FavoriteRounded', { keep: ['fontSize', 'color'] });
export const FilterAlt = wrap(MuiFilterAlt, 'FilterAlt', { keep: ['fontSize', 'color'] });
export const FilterList = wrap(MuiFilterList, 'FilterList', { keep: ['fontSize', 'color'] });
export const FitScreen = wrap(MuiFitScreen, 'FitScreen', { keep: ['fontSize', 'color'] });
export const FitnessCenter = wrap(MuiFitnessCenter, 'FitnessCenter', { keep: ['fontSize', 'color'] });
export const FoodBank = wrap(MuiFoodBank, 'FoodBank', { keep: ['fontSize', 'color'] });
export const Fullscreen = wrap(MuiFullscreen, 'Fullscreen', { keep: ['fontSize', 'color'] });
export const FullscreenExit = wrap(MuiFullscreenExit, 'FullscreenExit', { keep: ['fontSize', 'color'] });
export const Groups = wrap(MuiGroups, 'Groups', { keep: ['fontSize', 'color'] });
export const HeightRounded = wrap(MuiHeightRounded, 'HeightRounded', { keep: ['fontSize', 'color'] });
export const HelpOutline = wrap(MuiHelpOutline, 'HelpOutline', { keep: ['fontSize', 'color'] });
export const History = wrap(MuiHistory, 'History', { keep: ['fontSize', 'color'] });
export const Home = wrap(MuiHome, 'Home', { keep: ['fontSize', 'color'] });
export const HourglassEmpty = wrap(MuiHourglassEmpty, 'HourglassEmpty', { keep: ['fontSize', 'color'] });
export const Info = wrap(MuiInfo, 'Info', { keep: ['fontSize', 'color'] });
export const InfoOutlined = wrap(MuiInfoOutlined, 'InfoOutlined', { keep: ['fontSize', 'color'] });
export const InsertChart = wrap(MuiInsertChart, 'InsertChart', { keep: ['fontSize', 'color'] });
export const InsertDriveFile = wrap(MuiInsertDriveFile, 'InsertDriveFile', { keep: ['fontSize', 'color'] });
export const Key = wrap(MuiKey, 'Key', { keep: ['fontSize', 'color'] });
export const KeyboardArrowDown = wrap(MuiKeyboardArrowDown, 'KeyboardArrowDown', { keep: ['fontSize', 'color'] });
export const Language = wrap(MuiLanguage, 'Language', { keep: ['fontSize', 'color'] });
export const Link = wrap(MuiLink, 'Link', { keep: ['fontSize', 'color'] });
export const LinkOff = wrap(MuiLinkOff, 'LinkOff', { keep: ['fontSize', 'color'] });
export const Logout = wrap(MuiLogout, 'Logout', { keep: ['fontSize', 'color'] });
export const MarkEmailUnread = wrap(MuiMarkEmailUnread, 'MarkEmailUnread', { keep: ['fontSize', 'color'] });
export const Menu = wrap(MuiMenu, 'Menu', { keep: ['fontSize', 'color'] });
export const MonitorHeart = wrap(MuiMonitorHeart, 'MonitorHeart', { keep: ['fontSize', 'color'] });
export const MonitorWeight = wrap(MuiMonitorWeight, 'MonitorWeight', { keep: ['fontSize', 'color'] });
export const MonitorWeightOutlined = wrap(MuiMonitorWeightOutlined, 'MonitorWeightOutlined', { keep: ['fontSize', 'color'] });
export const MoreVert = wrap(MuiMoreVert, 'MoreVert', { keep: ['fontSize', 'color'] });
export const Pause = wrap(MuiPause, 'Pause', { keep: ['fontSize', 'color'] });
export const PlayArrow = wrap(MuiPlayArrow, 'PlayArrow', { keep: ['fontSize', 'color'] });
export const ToggleOff = wrap(MuiToggleOff, 'ToggleOff', { keep: ['fontSize', 'color'] });
export const ToggleOn = wrap(MuiToggleOn, 'ToggleOn', { keep: ['fontSize', 'color'] });
export const NavigateBefore = wrap(MuiNavigateBefore, 'NavigateBefore', { keep: ['fontSize', 'color'] });
export const NavigateNext = wrap(MuiNavigateNext, 'NavigateNext', { keep: ['fontSize', 'color'] });
export const Notifications = wrap(MuiNotifications, 'Notifications', { keep: ['fontSize', 'color'] });
export const People = wrap(MuiPeople, 'People', { keep: ['fontSize', 'color'] });
export const Person = wrap(MuiPerson, 'Person', { keep: ['fontSize', 'color'] });
export const PersonAdd = wrap(MuiPersonAdd, 'PersonAdd', { keep: ['fontSize', 'color'] });
export const PersonAddAlt1 = wrap(MuiPersonAddAlt1, 'PersonAddAlt1', { keep: ['fontSize', 'color'] });
export const PhotoCamera = wrap(MuiPhotoCamera, 'PhotoCamera', { keep: ['fontSize', 'color'] });
export const Pool = wrap(MuiPool, 'Pool', { keep: ['fontSize', 'color'] });
export const PrivacyTip = wrap(MuiPrivacyTip, 'PrivacyTip', { keep: ['fontSize', 'color'] });
export const Quiz = wrap(MuiQuiz, 'Quiz', { keep: ['fontSize', 'color'] });
export const Refresh = wrap(MuiRefresh, 'Refresh', { keep: ['fontSize', 'color'] });
export const RefreshRounded = wrap(MuiRefreshRounded, 'RefreshRounded', { keep: ['fontSize', 'color'] });
export const ReportProblemOutlined = wrap(MuiReportProblemOutlined, 'ReportProblemOutlined', { keep: ['fontSize', 'color'] });
export const Restaurant = wrap(MuiRestaurant, 'Restaurant', { keep: ['fontSize', 'color'] });
export const Scale = wrap(MuiScale, 'Scale', { keep: ['fontSize', 'color'] });
export const School = wrap(MuiSchool, 'School', { keep: ['fontSize', 'color'] });
export const ScienceOutlined = wrap(MuiScienceOutlined, 'ScienceOutlined', { keep: ['fontSize', 'color'] });
export const Search = wrap(MuiSearch, 'Search', { keep: ['fontSize', 'color'] });
export const SendOutlined = wrap(MuiSendOutlined, 'SendOutlined', { keep: ['fontSize', 'color'] });
export const Settings = wrap(MuiSettings, 'Settings', { keep: ['fontSize', 'color'] });
export const ShowChart = wrap(MuiShowChart, 'ShowChart', { keep: ['fontSize', 'color'] });
export const Spa = wrap(MuiSpa, 'Spa', { keep: ['fontSize', 'color'] });
export const Storage = wrap(MuiStorage, 'Storage', { keep: ['fontSize', 'color'] });
export const Straighten = wrap(MuiStraighten, 'Straighten', { keep: ['fontSize', 'color'] });
export const SupervisorAccount = wrap(MuiSupervisorAccount, 'SupervisorAccount', { keep: ['fontSize', 'color'] });
export const SupervisorAccountOutlined = wrap(MuiSupervisorAccountOutlined, 'SupervisorAccountOutlined', { keep: ['fontSize', 'color'] });
export const SwapHoriz = wrap(MuiSwapHoriz, 'SwapHoriz', { keep: ['fontSize', 'color'] });
export const SwapHorizRounded = wrap(MuiSwapHorizRounded, 'SwapHorizRounded', { keep: ['fontSize', 'color'] });
export const SwapVert = wrap(MuiSwapVert, 'SwapVert', { keep: ['fontSize', 'color'] });
export const TableRows = wrap(MuiTableRows, 'TableRows', { keep: ['fontSize', 'color'] });
export const Today = wrap(MuiToday, 'Today', { keep: ['fontSize', 'color'] });
export const TrackChangesRounded = wrap(MuiTrackChangesRounded, 'TrackChangesRounded', { keep: ['fontSize', 'color'] });
export const Translate = wrap(MuiTranslate, 'Translate', { keep: ['fontSize', 'color'] });
export const TrendingUpRounded = wrap(MuiTrendingUpRounded, 'TrendingUpRounded', { keep: ['fontSize', 'color'] });
export const TuneRounded = wrap(MuiTuneRounded, 'TuneRounded', { keep: ['fontSize', 'color'] });
export const ViewAgenda = wrap(MuiViewAgenda, 'ViewAgenda', { keep: ['fontSize', 'color'] });
export const ViewColumn = wrap(MuiViewColumn, 'ViewColumn', { keep: ['fontSize', 'color'] });
export const Visibility = wrap(MuiVisibility, 'Visibility', { keep: ['fontSize', 'color'] });
export const VisibilityOutlined = wrap(MuiVisibilityOutlined, 'VisibilityOutlined', { keep: ['fontSize', 'color'] });
export const VolunteerActivism = wrap(MuiVolunteerActivism, 'VolunteerActivism', { keep: ['fontSize', 'color'] });
export const WarningAmber = wrap(MuiWarningAmber, 'WarningAmber', { keep: ['fontSize', 'color'] });
export const Workspaces = wrap(MuiWorkspaces, 'Workspaces', { keep: ['fontSize', 'color'] });
export const ZoomIn = wrap(MuiZoomIn, 'ZoomIn', { keep: ['fontSize', 'color'] });
export const ZoomOut = wrap(MuiZoomOut, 'ZoomOut', { keep: ['fontSize', 'color'] });

/** What an icon is, for code that holds one in a variable or a map. */
export type IconComponent = typeof AccountCircle;
